/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FuelSurchargeValueHistory
 */
export interface FuelSurchargeValueHistory {
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueHistory
   */
  fuelSurchargeValueHistoryId?: string;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueHistory
   */
  fuelSurchargeId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FuelSurchargeValueHistory
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueHistory
   */
  changedBy?: string;
  /**
   *
   * @type {number}
   * @memberof FuelSurchargeValueHistory
   */
  previousValue?: number;
  /**
   *
   * @type {number}
   * @memberof FuelSurchargeValueHistory
   */
  newValue?: number;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueHistory
   */
  note?: string;
}

/**
 * Check if a given object implements the FuelSurchargeValueHistory interface.
 */
export function instanceOfFuelSurchargeValueHistory(
  value: object,
): value is FuelSurchargeValueHistory {
  return true;
}

export function FuelSurchargeValueHistoryFromJSON(
  json: any,
): FuelSurchargeValueHistory {
  return FuelSurchargeValueHistoryFromJSONTyped(json, false);
}

export function FuelSurchargeValueHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FuelSurchargeValueHistory {
  if (json == null) {
    return json;
  }
  return {
    fuelSurchargeValueHistoryId:
      json["fuelSurchargeValueHistoryId"] == null
        ? undefined
        : json["fuelSurchargeValueHistoryId"],
    fuelSurchargeId:
      json["fuelSurchargeId"] == null ? undefined : json["fuelSurchargeId"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    changedBy: json["changedBy"] == null ? undefined : json["changedBy"],
    previousValue:
      json["previousValue"] == null ? undefined : json["previousValue"],
    newValue: json["newValue"] == null ? undefined : json["newValue"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function FuelSurchargeValueHistoryToJSON(
  json: any,
): FuelSurchargeValueHistory {
  return FuelSurchargeValueHistoryToJSONTyped(json, false);
}

export function FuelSurchargeValueHistoryToJSONTyped(
  value?: FuelSurchargeValueHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fuelSurchargeValueHistoryId: value["fuelSurchargeValueHistoryId"],
    fuelSurchargeId: value["fuelSurchargeId"],
    updatedAt: value["updatedAt"],
    changedBy: value["changedBy"],
    previousValue: value["previousValue"],
    newValue: value["newValue"],
    note: value["note"],
  };
}
